import moment from 'moment';
import { get as getFacture } from '@/api/facture';
import { get as getTiers } from '@/api/tiers';

function formatDDMMYY(date) {
  return date.format('DD') + date.format('MM') + date.format('YY');
}

async function getAllFacture(ids) {
  const promiseFacture = [];
  ids.forEach((id) => {
    promiseFacture.push(getFacture(id));
  });
  const factures = (await Promise.all(promiseFacture))
    .map((facture) => facture.data.result);
  return factures;
}

async function getAllPayeurs(factures) {
  let payeursIds = [];
  factures.forEach((facture) => {
    const payeur = facture.intervenants.find((int) => { return int.payeur; });
    payeursIds.push(payeur.tiersId);
  });
  payeursIds = [...new Set(payeursIds)];
  const promiseTiers = [];
  payeursIds.forEach((id) => {
    promiseTiers.push(getTiers(id));
  });
  const payeurs = (await Promise.all(promiseTiers))
    .map((tiers) => tiers.data.result);
  return payeurs;
}

export default async function createStringToExportPrelevement(facturesIds) {
  const factures = await getAllFacture(facturesIds);
  const payeurs = await getAllPayeurs(factures);
  const facturesSort = factures.sort((factureA, factureB) => {
    return factureA.code.localeCompare(factureB.code);
  });

  let stringToExport = '';

  facturesSort.forEach((facture) => {
    const echeancesSort = facture.echeancierPaiement.sort((echeA, echeB) => {
      if (moment(echeA.dateEcheance).isAfter(moment(echeB.dateEcheance))) return 1;
      if (moment(echeA.dateEcheance).isBefore(moment(echeB.dateEcheance))) return -1;
      return 0;
    });
    echeancesSort.forEach((echeance) => {
      const payeurInFacture = facture.intervenants.find((int) => { return int.payeur; });
      const infoPayeur = payeurs.find((payeur) => {
        return payeur.id === payeurInFacture.tiersId;
      });
      stringToExport += 'PRL\t';
      stringToExport += formatDDMMYY(moment(facture.dateDevisCommande)) + '\t';
      stringToExport += formatDDMMYY(moment(echeance.dateEcheance)) + '\t';
      stringToExport += infoPayeur.compteComptable + '\t';
      stringToExport += (facture.reference ? facture.reference.code : '') + '\t';
      stringToExport += echeance.montant.toString().replaceAll('.', ',') + '\t';
      stringToExport += facture.code + '\n';
    });
  });
  return stringToExport;
}
